import React from "react";
import {Link} from 'react-router-dom';

const Footer = () => {
    console.log("we are running version ", VERSION);
        return (
            <footer className="app-footer">
                <div className="d-flex flex-row justify-content-between">
                    <span> &copy; 2018-2019 DNS:NET GmbH (v{VERSION})</span><span><Link to="/app/impressum">Impressum</Link></span>
                </div>
            </footer>
        );
    }
;

export default Footer;
